import { RootState } from '../../types';

export const active = (state: RootState) => state.app.globalLoader.isActive;
